import { ParentModel } from '@blueprint/frontend-basics'
import { IsString, IsUUID, MaxLength } from 'class-validator'


export class TaleDto extends ParentModel {
  @IsUUID()
  id?: string

  @IsString()
  @MaxLength(255)
  title?: string
}
